exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".response-container[data-v-47b0baed]{padding:20px;background:#fff;border-radius:8px;box-shadow:0 0 10px rgba(0,0,0,.1)}h1[data-v-47b0baed]{font-size:24px;margin-bottom:20px}ul[data-v-47b0baed]{list-style:none;padding:0}li[data-v-47b0baed]{margin-bottom:10px;font-size:18px}strong[data-v-47b0baed]{font-weight:700}.card[data-v-47b0baed]{box-shadow:0 .125rem .25rem rgba(0,0,0,.075)}.card-header[data-v-47b0baed]{background-color:#f8f9fa;border-bottom:1px solid #dee2e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47b0baed","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ulip/ECHALLAN_ResponseDisplay.vue
// module id = 1561
// module chunks = 0